module.exports = __webpack_public_path__ + "static/media/taper.3ad760ff.svg";